import { customReducer } from './customReducer'

export default function uploadDataReducer(state, action) {
  return customReducer(state, action, 'uploadData', ['GET_ALL_UPLOAD_DATA'])
}
